<template>
  <div
    class="pt-list-item bg-white w-full border-b border-grey-light flex cursor-pointer flex-col text-black"
    @click="onListItemClicked"
  >
    <div :class="topSectionClass">
      <i
        v-if="$parent.isCollapsible"
        :class="anchorClass"
      />
      <slot />
    </div>
    <div
      v-show="showSubSection && !isHeader"
      class="p-4 pt-collapsible-section"
    >
      <slot name="collapsible" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PtListItem',
  props: {
    isHeader: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showSubSection: false,
    };
  },
  computed: {
    anchorClass() {
      return {
        'fa text-grey mr-2 pt-list-item__collapse-indicator': !this.isHeader,
        'fa-chevron-right': !this.showSubSection,
        'fa-chevron-down': this.showSubSection,
        'invisible': this.isHeader,
      };
    },
    topSectionClass() {
      return {
        'border-b border-grey-light': this.showSubSection && !this.isHeader,
        'p-4 flex flex-row w-full items-center': true,
      };
    },
  },
  methods: {
    onListItemClicked(e) {
      if (this.$parent.isCollapsible) {
        this.showSubSection = !this.showSubSection;
        const expansionEvent = this.showSubSection ? 'list-item-expanded' : 'list-item-collapsed';

        this.$emit(expansionEvent, e);
      }

      this.$emit('list-item-clicked');
    },
  },
};
</script>
